import { formatDate } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-districtwise-subscription-report',
  templateUrl: './districtwise-subscription-report.component.html',
  styleUrls: ['./districtwise-subscription-report.component.scss'],
})
export class DistrictwiseSubscriptionReportComponent implements OnInit {
  startDate = '';
  endDate = '';
  subData;
  districtwiseData = [];
  districtwiseDataTotal = {};
  districtwiseDataTotalTest = {};
  subTypesName = [
    { name: 'वार्षिक', isVisible: false },
    { name: 'त्रैवार्षिक', isVisible: false },
    { name: 'पंचवार्षिक', isVisible: false },
    { name: 'मुदत ठेव (पंचवार्षिक वर्गणीदार)', isVisible: false },
    { name: 'रामसेवक ग्रंथयात्री', isVisible: false },
    { name: 'लोकनेता गंथयात्री वार्षिक', isVisible: false },
    { name: 'लोकमान्य ग्रंथयात्री वार्षिक वर्गणी', isVisible: false },
    { name: 'हिंदुत्व ग्रंथयात्री', isVisible: false },
    { name: 'हिंदुत्व 1', isVisible: false },
    { name: 'हिंदुत्व 2', isVisible: false },
    { name: 'आजीव', isVisible: false },
    { name: 'अनामत', isVisible: false },
  ];
  isLoading = false;
  test = [
    'हितचिंतक सप्रेम भेट',
    'सप्रेम भेट - संपादकीय विभाग',
    'जाहिरात स. भेट',
    'संघ परिवार सप्रेम भेट',
    'वर्गणी सप्रेम भेट',
  ];
  totalth = 0;
  district: any;
  country: any;
  state: any;
  taluka: any;
  Subscription_Type: any;

  constructor(
    private dialogRef: MatDialogRef<DistrictwiseSubscriptionReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.subData = this.data['data'].filter((a) => {
      this.district = this.data['district_name'];
    this.country = this.data['country'];
    this.state = this.data['state_name'];
    this.taluka = this.data['taluka_name'];
    this.Subscription_Type = this.data['Subscription_Type'];
      return a.delivery_mode;
      // return a.delivery_mode == 'टपाल';
    });
    let data = this.uniqueData(this.subData, (a) => a.Subscription_Type);

    for (let i = 0; i < Object.keys(data).length; i++) {
      let flag = false;
      for (let j = 0; j < Object.keys(this.subTypesName).length; j++) {
        if (data[i]['Subscription_Type'] === this.subTypesName[j]['name']) {
          this.subTypesName[j]['isVisible'] = true;
          flag = true;
          break;
        }
      }
      if (!flag) {
        if (
          data[i]['Subscription_Type'] !== 'हितचिंतक सप्रेम भेट' ||
          data[i]['Subscription_Type'] !== 'सप्रेम भेट - संपादकीय विभाग' ||
          data[i]['Subscription_Type'] !== 'जाहिरात स. भेट' ||
          data[i]['Subscription_Type'] !== 'संघ परिवार सप्रेम भेट' ||
          data[i]['Subscription_Type'] !== 'वर्गणी सप्रेम भेट'
        ) {
          this.subTypesName.push({
            name: data[i]['Subscription_Type'],
            isVisible: true,
          });
        }
      }
    }

    this.subTypesName.map((a: any) => {
      let name = a['name'].replaceAll(' ', '_');
      this.districtwiseDataTotalTest[name] = 0;
    });

    this.districtwiseDataTotal = {
      ...this.districtwiseDataTotalTest,
      सप्रेम_भेट_1: 0,
      सप्रेम_भेट_2: 0,
      एकूणसप्रेम_भेट: 0,
      एकूण: 0,
      सप्रेम_एकूण: 0,
    };
    this.totalth = this.subTypesName.length + 8;

    this.endDate = this.data['issuedate'];
    let weekfirstday =
      new Date(this.data['issuedate']).getDate() -
      new Date(this.data['issuedate']).getDay();
    this.startDate = formatDate(
      new Date(this.data['issuedate']).setDate(weekfirstday - 7),
      'yyyy-MM-dd',
      'en-IN',
      'GMT+0530'
    );

    this.setSubData();
  }

  setSubData() {
    let data = this.uniqueData(this.subData, (a) => a.district);
    data.sort((a: any, b: any) => {
      return b.district.localeCompare(a.district);
    });

    for (let i = 0; i < data.length; i++) {
      let districtData = this.subData.filter((a) => {
        return a.district == data[i]['district'];
      });
      let subType = this.uniqueData(districtData, (a) => a.Subscription_Type);

      for (let j = 0; j < subType.length; j++) {
        let subTypeData = districtData.filter((a) => {
          return a.Subscription_Type == subType[j]['Subscription_Type'];
        });

        let totalSubType = 0;
        subTypeData.map((a) => {
          if (a.s_bhet != null) {
            totalSubType += parseInt(a.s_bhet);
          }
        });

        this.setSubTypeData(
          data[i]['district'],
          this.getKey(subType[j]['Subscription_Type']),
          subTypeData.length,
          totalSubType,
          j == subType.length - 1 ? true : false
        );
      }
    }
    this.calculateTotal();
  }

  //Old Code
  // setSubTypeData(
  //   districtName: string,
  //   subType: string,
  //   total: number,
  //   sbhet: number,
  //   last: boolean
  // ) {
  //   let foundDistrict = this.districtwiseData.filter((a) => {
  //     return a.districtName == districtName;
  //   });

  //   if (foundDistrict.length == 0) {
  //     this.subTypesName.map((a: any) => {
  //       let name = a['name'].replaceAll(' ', '_');
  //       this.districtwiseDataTotalTest[name] = 0;
  //     });

  //     this.districtwiseData.push({
  //       districtName,
  //       ...this.districtwiseDataTotalTest,
  //       सप्रेम_भेट_1: 0,
  //       सप्रेम_भेट_2: 0,
  //       एकूणसप्रेम_भेट: 0,
  //       एकूण: 0,
  //       सप्रेम_एकूण: 0,
  //     });
  //   }

  //   if (!this.test.includes(subType)) {
  //     this.setDistrictData(districtName, subType, 'एकूण', total);
  //   } else {
  //     this.districtwiseData.map((a) => {
  //       if (a.districtName == districtName) {
  //         a['सप्रेम_भेट_1'] += total;
  //         a['एकूण'] += total;
  //         return;
  //       }
  //     });
  //   }

  //   this.districtwiseData.map((a) => {
  //     if (a.districtName == districtName) {
  //       a['सप्रेम_भेट_1'] += sbhet;
  //       a['एकूणसप्रेम_भेट'] += sbhet;
  //       return;
  //     }
  //   });

  //   if (last) {
  //     this.districtwiseData.map((a) => {
  //       if (a.districtName == districtName) {
  //         a['सप्रेम_एकूण'] =
  //           parseInt(a['एकूण']) + parseInt(a['एकूणसप्रेम_भेट']);
  //         return;
  //       }
  //     });
  //   }
  // }


  setSubTypeData(districtName, subType, total, sbhet, last) {

  total = Number(total) || 0;
  sbhet = Number(sbhet) || 0;

  function normalizeName(str: string) {
    return str
      .replace(/_/g, ' ')
      .replace(/–/g, '-')
      .replace(/\s+/g, ' ')
      .trim();
  }

  let originalName = normalizeName(subType);

  const SPECIAL_TYPES = [
    'हितचिंतक सप्रेम भेट',
    'सप्रेम भेट - संपादकीय विभाग',
    'सप्रेम भेट-जाहिरात प्रतिनीधी',
    'सप्रेम भेट-संघ परिवार',
    'वर्गणी सप्रेम भेट',
    'सप्रेम भेट-वर्गणीदार प्रतिनीधी'
  ].map(normalizeName);

  const isSpecialType = SPECIAL_TYPES.some(type => originalName.includes(type));

  let foundDistrict = this.districtwiseData.find(
    a => a.districtName === districtName
  );

  if (!foundDistrict) {

    this.subTypesName.forEach(a => {
      let key = a['name'].split(' ').join('_');
      this.districtwiseDataTotalTest[key] = 0;
    });

    foundDistrict = {
      districtName,
      ...this.districtwiseDataTotalTest,
      सप्रेम_भेट_1: 0,
      सप्रेम_भेट_2: 0,
      एकूणसप्रेम_भेट: 0,  
      एकूण: 0,
      सप्रेम_एकूण: 0,
    };

    this.districtwiseData.push(foundDistrict);
  }

  if (!this.test.includes(subType)) {

    this.setDistrictData(districtName, subType, 'एकूण', total);

    // ⭐ Add sbhet for special types
    if (isSpecialType) {
      foundDistrict['एकूणसप्रेम_भेट'] += total;
      foundDistrict['एकूण'] -= total;
    }
  }

  else {

    foundDistrict['सप्रेम_भेट_1'] += total;
    foundDistrict['एकूण'] += total;

    // ⭐ Add sbhet for special types
    if (isSpecialType) {
      foundDistrict['एकूणसप्रेम_भेट'] += total;
      foundDistrict['एकूण'] -= total;
    }
  }

  if (last) {
    foundDistrict['सप्रेम_एकूण'] =
      Number(foundDistrict['एकूण']) +
      Number(foundDistrict['एकूणसप्रेम_भेट']);
  }
}


  getKey(name) {
    return name.replaceAll(' ', '_');
  }

  setDistrictData(
    districtName: string,
    subtype: string,
    aikun: string,
    total: number
  ) {
    this.districtwiseData.map((a) => {
      if (a.districtName == districtName) {
        a[subtype] = total;
        a[aikun] += total;
        return;
      }
    });
  }

  //Zero value Show in Report old Correct Method
  // calculateTotal() {
  //   this.districtwiseData.map((a) => {
  //     this.subTypesName.map((b) => {
  //       let key = this.getKey(b.name);
  //       this.districtwiseDataTotal[key] += a[key];
  //     });
  //     this.districtwiseDataTotal['सप्रेम_भेट_1'] += a['सप्रेम_भेट_1'];
  //     this.districtwiseDataTotal['सप्रेम_भेट_2'] += a['सप्रेम_भेट_2'];
  //     this.districtwiseDataTotal['एकूणसप्रेम_भेट'] += a['एकूणसप्रेम_भेट'];
  //     this.districtwiseDataTotal['एकूण'] += a['एकूण'];
  //     this.districtwiseDataTotal['सप्रेम_एकूण'] += a['सप्रेम_एकूण'];
  //   });
  //   this.isLoading = false;
  // }

calculateTotal() {
  this.districtwiseData.map((a) => {
    this.subTypesName.map((b) => {
      let key = this.getKey(b.name);
      this.districtwiseDataTotal[key] += Number(a[key]) || 0;
    });

    this.districtwiseDataTotal['सप्रेम_भेट_1'] += Number(a['सप्रेम_भेट_1']) || 0;
    this.districtwiseDataTotal['सप्रेम_भेट_2'] += Number(a['सप्रेम_भेट_2']) || 0;
    this.districtwiseDataTotal['एकूणसप्रेम_भेट'] += Number(a['एकूणसप्रेम_भेट']) || 0;
    this.districtwiseDataTotal['एकूण'] += Number(a['एकूण']) || 0;
    this.districtwiseDataTotal['सप्रेम_एकूण'] += Number(a['सप्रेम_एकूण']) || 0;
  });

  /* ⭐ NEW CODE : convert 0 to empty only for display */
  this.districtwiseData.forEach(row => {
    Object.keys(row).forEach(key => {
      if (row[key] === 0) {
        row[key] = '';
      }
    });
  });

  this.isLoading = false;
}

  uniqueData(data, key) {
    return [...new Map(data.map((a) => [key(a), a])).values()];
  }

  exportExcel(fileName) {
    /* table id is passed over here */
    let element = document.getElementById('print-section1');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName + '.xlsx');
  }

  //Old Method
// printPage() {
//   const section = document.getElementById('print-section1');
//   if (!section) {
//     console.error("Print section not found!");
//     return;
//   }

//   const printWindow = window.open('', '', 'width=1400,height=1000');

//   const htmlContent = `
//     <html>
//       <head>
//         <title>Print Report</title>
//         <style>
//           @media print {
//             @page {
//               size: A3 landscape;
//               margin: 10mm;
//             }

//             body {
//               font-family: Arial, sans-serif;
//               font-size: 12px;
//               margin: 0;
//               padding: 0;
//             }

//             table {
//               width: 100%;
//               border-collapse: collapse;
//               table-layout: fixed;
//             }

//             th {
//               border: 1px solid black;
//               word-break: break-word !important;
//               padding: 3px 5px;
//               font-size: 10px;
//             }

//             td {
//               border: 1px solid black;
//               padding: 3px 5px;
//               font-size: 12px;
//             }

//             /* FIX: district name in single line inside column */
//             .district-col {
//               font-size: 10px !important;
//               white-space: nowrap !important;
//               overflow: hidden !important;
//               text-overflow: ellipsis !important;
//             }

//             tr {
//               page-break-inside: avoid;
//             }

//             .noPrint { display: none; }
//           }

//           th, td {
//             border: 1px solid black;
//             padding: 3px 5px;
//             text-align: center;
//           }
//         </style>
//       </head>
//       <body>
//         ${section.outerHTML}
//         <script>
//           window.onload = function() {
//             window.print();
//             setTimeout(() => window.close(), 500);
//           };
//         </script>
//       </body>
//     </html>
//   `;

//   printWindow.document.open();
//   printWindow.document.write(htmlContent);
//   printWindow.document.close();
// }

printPage() {
  const section = document.getElementById('print-section1');
  if (!section) {
    console.error("Print section not found!");
    return;
  }

  const printWindow = window.open('', '', 'width=1400,height=1000');

  const htmlContent = `
    <html>
      <head>
        <title>Print Report</title>
        <style>
          @media print {
            @page {
              size: A3 landscape;
              margin: 10mm;
            }

            body {
              font-family: Arial, sans-serif;
              font-size: 12px;
              margin: 0;
              padding: 0;
            }

            table {
              width: 100%;
              border-collapse: collapse;
              table-layout: auto; /* changed from fixed */
            }

            th {
              border: 1px solid black;
              word-break: break-word !important;
              padding: 3px 5px;
              font-size: 12px;
            }

            td {
              border: 1px solid black;
              padding: 3px 5px;
              font-size: 12px;
            }

            /* District column expands as per name */
            .district-col {
              font-size: 10px !important;
              white-space: nowrap !important;
              min-width: 120px;
            }

            tr {
              page-break-inside: avoid;
            }

            .noPrint { display: none; }
          }

          th{
            border: 1px solid black;
            padding: 3px 5px;
            text-align: center;
          }

           td {
            border: 1px solid black;
            padding: 3px 5px;
            text-align: left;
          }
        </style>
      </head>
      <body>
        ${section.outerHTML}
        <script>
          window.onload = function() {
            window.print();
            setTimeout(() => window.close(), 500);
          };
        </script>
      </body>
    </html>
  `;

  printWindow.document.open();
  printWindow.document.write(htmlContent);
  printWindow.document.close();
}
}
